import React, { useState } from "react";
import { Button, ViewBooking } from "../../../../../../Components";
import { useNavigate } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";

function BookingFailed({ booking }) {
	const [BookingId, setBookingId] = useState();
	const errorMessage = booking?.error || "We are facing problems in booking this flight you can go back and try again, or choose a different flight. If money was deducted it will refunded automatically.";

	const NAVIGATE = useNavigate();
	return (
		<div className="w-full h-full flex-center bg-light">
			<div className="p-8 border shadow-sm bg-canvas rounded-xl max-w-lg w-full">
				<div className="h-20 flex-center">
					<FiAlertTriangle className="w-10 h-10 text-warning m-auto mb-4" />
				</div>
				<div className="mt-4 text-center">
					<h1>Booking Failed</h1>
					<div className="mt-4 text-label">{errorMessage}</div>
					{(booking?.flowId || booking?.traceId) && (
						<div className="mt-4 text-xs text-secondary space-y-1">
							{booking?.flowId && (
								<div>
									<span className="font-medium">Flow ID:</span> <span className="font-mono break-all">{booking.flowId}</span>
								</div>
							)}
							{booking?.traceId && (
								<div>
									<span className="font-medium">Trace ID:</span> <span className="font-mono break-all">{booking.traceId}</span>
								</div>
							)}
						</div>
					)}
					<div className="flex items-center justify-center gap-4 mt-6">
						<Button onClick={() => NAVIGATE(`/app/travel`)}>Go Back</Button>
						{booking?.bookingId && (
							<Button onClick={() => setBookingId(booking.bookingId)} variant="outlined">
								View Booking
							</Button>
						)}
					</div>
					<ViewBooking id={BookingId} type="flight" onClose={() => setBookingId()} />
				</div>
			</div>
		</div>
	);
}

export default BookingFailed;
